import React, { createContext, useContext, useState } from 'react';
import { createBrowserRouter, RouterProvider, useRouteError } from 'react-router';

const ResQRouterChildrenContext = createContext<React.ReactNode>(null);

const ResQRouterChildren = () => useContext(ResQRouterChildrenContext);

const ResQRouterError = () => {
    // Keep route render failures owned by App's outer Sentry ErrorBoundary.
    throw useRouteError();
};

export const ResQRouter = ({ children }: { children: React.ReactNode }) => {
    const [router] = useState(() =>
        createBrowserRouter([
            {
                path: '*',
                element: <ResQRouterChildren />,
                errorElement: <ResQRouterError />,
            },
        ]),
    );

    return (
        <ResQRouterChildrenContext.Provider value={children}>
            <RouterProvider router={router} />
        </ResQRouterChildrenContext.Provider>
    );
};
